import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const CaretDownIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="m15.293 19.293-5.586-5.586c-.63-.63-.184-1.707.707-1.707h11.172c.89 0 1.337 1.077.707 1.707l-5.586 5.586a1 1 0 0 1-1.414 0Z" />
  </BaseIcon>
);
